import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Bookmark, Newspaper, GraduationCap, Stethoscope } from "lucide-react";
import { useAuth } from "../AuthContext";
import { API_URL } from "../config";

const KIND_CONFIG = {
  post:    { path: "articles", label: "Статья", icon: Newspaper, color: "#007c84" },
  case:    { path: "cases", label: "Клинический случай", icon: Stethoscope, color: "#e5005b" },
  lecture: { path: "lectures", label: "Материал", icon: GraduationCap, color: "#15803d" },
};

export default function SavedItems() {
  const { isLoggedIn, token } = useAuth();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!isLoggedIn) { setLoading(false); return; }
    fetch(`${API_URL}/bookmarks/mine`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => r.ok ? r.json() : [])
      .then(setItems)
      .catch(() => setItems([]))
      .finally(() => setLoading(false));
  }, [isLoggedIn, token]);

  if (!isLoggedIn) {
    return (
      <section>
        <h1 className="section-title">Сохранённое</h1>
        <p style={{ color: "#888" }}>Войдите, чтобы видеть сохранённые материалы.</p>
      </section>
    );
  }

  return (
    <section>
      <h1 className="section-title">Сохранённое</h1>
      {loading && <p style={{ color: "#888" }}>Загрузка…</p>}
      {!loading && items.length === 0 && (
        <p style={{ color: "#999", fontStyle: "italic" }}>
          Пока ничего не сохранено. Нажмите «Сохранить» под статьёй, материалом или случаем, чтобы вернуться к нему позже.
        </p>
      )}
      {items.map(it => {
        const cfg = KIND_CONFIG[it.content_type];
        if (!cfg) return null;
        const Icon = cfg.icon;
        return (
          <div className="card" key={`${it.content_type}_${it.content_id}`}>
            <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 6 }}>
              <span style={{ display: "inline-flex", alignItems: "center", gap: 4, background: cfg.color, color: "#fff", borderRadius: 6, padding: "2px 10px", fontSize: "0.78rem", fontWeight: 600 }}>
                <Icon size={12} strokeWidth={2.4} /> {cfg.label}
              </span>
              <span style={{ fontSize: "0.85rem", color: "#aaa", marginLeft: "auto" }}>
                <Bookmark size={12} strokeWidth={2.2} style={{ verticalAlign: -2, marginRight: 3 }} />
                Сохранено {new Date(it.saved_at).toLocaleDateString("ru")}
              </span>
            </div>
            <Link to={`/${cfg.path}/${it.content_id}`} style={{ textDecoration: "none" }}>
              <div style={{ fontWeight: 700, fontSize: "1.05rem", color: "#007c84" }}>{it.title}</div>
            </Link>
          </div>
        );
      })}
    </section>
  );
}
